import React,{useEffect, useState} from 'react'
import Layout from '../../components/Layout/Layout'
import axios from "axios";
import {useNavigate, useParams} from 'react-router-dom'
import {Form} from 'react-bootstrap';
import toast from 'react-hot-toast';
import '../../style/AuthStyle.css';
import 'rsuite/dist/rsuite.min.css';
import { SERVER_API } from '../../fileWithConstants'
import FabricOpeningBalanceRow from './FabricOpeningBalanceRow';
const AddFabricOpeningBalance = () => {
const params = useParams();
const navigate = useNavigate();
const [rowsData, setRowsData] = useState([]);
const [mainFabricData, setMainFabricData] = useState({});
const [validated, setValidated] = useState(false);

const handleAddOpeningBalance = async (e) => {
  e.preventDefault();
  const form = e.currentTarget;
  if (form.checkValidity() === false) {
    e.stopPropagation();
    return;
  }
  setValidated(true);

  try {
    const formData = new FormData();
    formData.append('mainFabricData', JSON.stringify(mainFabricData)); // Attach fabric opening rows
    formData.append('rows', JSON.stringify(rowsData)); // Attach fabric opening rows

    const { data } = await axios.post(`${SERVER_API}/api/v1/fabric/add-fabric-opening-balance/${params.fid}`, formData);
    
    if (data?.success) {
      toast.success(data?.message);
      navigate('/dashboard/fabric-list');
    } else {
      toast.error(data?.message);
    }
  } catch (error) {
    console.log(error);
    toast.error("Something went wrong.");
  }
};


const singleFabricData = async()=>{
  try {
      const {data} = await axios.get(`${SERVER_API}/api/v1/fabric/get-main-fabric-data/${params.fid}`);
     if(data?.success){
        if(data.fabric.length>0){
          setMainFabricData(data.fabric[0]);
        }
     }
      
  } catch (error) {
      console.log(error)
  }
}

useEffect(()=>{
  singleFabricData();
},[params.fid])



const cancelHandle = ()=>{
  navigate('/dashboard/fabric-list');
}

  return (
  <Layout title={'Add Fabric Opening Balance'}>
    <div className="container my-4">
      <div className="card shadow p-4">
        <h4 className="mb-4">Add Fabric Opening Balance</h4>
        <Form onSubmit={handleAddOpeningBalance} encType="multipart/form-data" noValidate validated={validated}>
          <table className="table table-bordered align-middle">
            <thead className="table-light">
              <tr>
                <th>Fabric Name</th>
                <th>Supplier Fabric Name</th>
                <th>Supplier Name</th>
                <th>Price</th>
                <th>Category</th>
                <th>Quantity (metres)</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  {mainFabricData.name || ''}
                </td>
                <td>
                   {mainFabricData.supplierfbname || ''}
                </td>
                 <td>
                   {mainFabricData.supp_name || ''}
                </td>
                <td>
                    {mainFabricData.price || ''}
                </td>
                <td>
                    {mainFabricData.category_name || ''}
                </td>
                <td>
                    {mainFabricData.total_in}
                </td>                
              </tr>
            </tbody>
          </table>
          
          <FabricOpeningBalanceRow onDataChange={(rows) => setRowsData(rows)} />

          {/* Buttons */}
          <div className="row justify-content-center mt-4">
            <div className="col-md-2 mb-2">
              <button type="submit" className="btn btn-success w-100">Add Balance</button>
            </div>
            <div className="col-md-2 mb-2">
              <button type="button" onClick={cancelHandle} className="btn btn-secondary w-100">Back</button>
            </div>
          </div>
        </Form>
      </div>
    </div>
  </Layout>
);


}

export default AddFabricOpeningBalance
